export default {"src":"/_next/static/media/Rosacea.eb351e46.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};